import { createSelector } from 'reselect';

const selectQuestion = (state) => state.question;

const selectQuestionsList = createSelector(
	selectQuestion,
	(question) => question?.list
);

const selectQuetionSubmittedReply = createSelector(
	selectQuestion,
	(question) => question?.submittedReply
);

const questionSelectors = {
	selectQuestion,
	selectQuestionsList,
	selectQuetionSubmittedReply,
};

export default questionSelectors;
